import React from "react";
import { CookieConsent } from "./CookieConsent";
import { useCookieConsent } from "./hooks/useCookieConsent";

interface ICookieConsentProviderProps {
  children: React.ReactNode;
}

export const CookieConsentProvider: React.FC<ICookieConsentProviderProps> = ({
  children,
}) => {
  const { showBanner, acceptCookies, declineCookies } = useCookieConsent();

  return (
    <>
      {children}
      {showBanner && (
        <CookieConsent 
          onAccept={acceptCookies} 
          onDecline={declineCookies}
        />
      )}
    </>
  );
};